import React, { FC } from 'react'
import { TeamListItem } from './components/TeamListItem/TeamListItem'
import { ChannelTeamItem } from 'pages/native/onBoarding/types/types'
import { EmptyList } from './components/EmptyList/EmptyList'
import { ListError } from './components/ListError/ListError'
import { Skeleton } from 'pages/native/onBoarding/components'

interface TeamListProps {
  teams: ChannelTeamItem[]
  isLoading: boolean
  isError: boolean
  onResetSearch: () => void
  isFetchingNextPage: boolean
}

export const TeamList: FC<TeamListProps> = ({
  teams,
  isLoading,
  isError,
  onResetSearch,
  isFetchingNextPage
}) => {
  if (isLoading && !isFetchingNextPage) {
    return <Skeleton type="table" rows={5} />
  }

  if (isError) {
    return <ListError />
  }
  if (!teams || teams.length === 0) {
    return <EmptyList onReset={onResetSearch} />
  }
  return (
    <div>
      {teams.map((item) => (
        <TeamListItem key={item.id} team={item} />
      ))}
    </div>
  )
}
